import React from 'react';
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';

const RequestConfirmationModal = ({ isOpen, onClose, requestData }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen p-4">
        {/* Background overlay */}
        <div
          className="fixed inset-0 bg-black bg-opacity-75 transition-opacity"
          onClick={onClose}
        ></div>

        {/* Modal */}
        <div className="relative bg-gray-800 rounded-xl text-left overflow-hidden shadow-xl transform transition-all w-full max-w-md mx-auto">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-700">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                <CheckIcon className="h-6 w-6 text-white" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white">
                  Request Submitted!
                </h3>
                <p className="text-sm text-white">
                  Your purchase request has been sent
                </p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:text-white transition-colors"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6 space-y-4">
            {/* Request Details */}
            <div className="bg-gray-700 rounded-lg p-4">
              <h4 className="text-sm font-medium text-white mb-3">Request Details</h4>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-white">Amount:</span>
                  <span className="text-white">
                    {requestData?.fiat_amount?.toLocaleString()} {requestData?.fiat_currency}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-white">BTC1 Amount:</span>
                  <span className="text-white">
                    {requestData?.btc1_amount?.toFixed(6)} BTC1
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-white">BTC1 Price:</span>
                  <span className="text-white">
                    ${requestData?.btc1_price?.toLocaleString()}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-white">Payment Method:</span>
                  <span className="text-white capitalize">
                    {requestData?.payment_method?.replace('_', ' ')}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-white">Request ID:</span>
                  <span className="text-white font-mono text-xs">
                    {requestData?.request_id}
                  </span>
                </div>
              </div>
            </div>

            {/* Email Warning */}
            {requestData?.warning && (
              <div className="bg-yellow-900 bg-opacity-50 border border-[#2A356D] rounded-lg p-4">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-[#0E1696] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-white text-xs font-bold">⚠</span>
                  </div>
                  <div>
                    <h4 className="text-white font-medium mb-1">Email Notification Issue</h4>
                    <p className="text-yellow-100 text-sm">{requestData.warning}</p>
                  </div>
                </div>
              </div>
            )}

            {/* Next Steps */}
            <div className="bg-blue-900 bg-opacity-50 border border-blue-600 rounded-lg p-4">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-white text-xs font-bold">i</span>
                </div>
                <div>
                  <h4 className="text-blue-300 font-medium mb-2">What happens next?</h4>
                  <ul className="text-blue-100 text-sm space-y-1">
                    <li>• Our representative will contact you within 48 hours</li>
                    <li>• We'll provide payment instructions and details</li>
                    <li>• Once payment is confirmed, BTC1 will be credited to your account</li>
                    <li>• You'll receive email updates throughout the process</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Contact Info */}
            <div className="bg-gray-700 rounded-lg p-4">
              <h4 className="text-sm font-medium text-white mb-2">Need immediate assistance?</h4>
              <p className="text-white text-sm">
                Contact our support team at{' '}
                <a 
                  href="mailto:support@P2P1.com" 
                  className="text-white hover:text-white transition-colors"
                >
                  support@P2P1.com
                </a>
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="px-6 py-4 bg-gray-750 border-t border-gray-700">
            <button
              onClick={onClose}
              className="w-full bg-[#0E1696] hover:bg-[#0E1696] text-white py-3 text-sm font-semibold rounded-lg transition-all duration-200"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestConfirmationModal;
